import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import type PocketBase from 'pocketbase';
import { ConfirmProvider } from '~/components/ConfirmDialog/ConfirmDialog';
import { GlobalLoader } from '~/components/GlobalLoader/GlobalLoader';

interface RouterContext {
  pb: PocketBase;
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  return (
    <ConfirmProvider>
      <GlobalLoader />
      <Outlet />
    </ConfirmProvider>
  );
}
